<template>
  <v-dialog v-model="dialogCreate" persistent max-width="1200px">
      <template v-slot:activator="{}">
      </template>
      <v-card>
        <v-card-title>
          <span class="headline txt-head">{{textTitle}} Employee</span>
        </v-card-title>
          <v-container class="ma-2">
            <div class="text-right" v-if="textTitle === 'View'">
              <v-btn class="ma-2" outlined small fab color="indigo">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </div>
            <v-layout class="row">
              <v-col cols="2">
                <p class="txt-font">Username or E-mail</p>
              </v-col>
              <v-col cols="4" class="form-control">
                  <v-text-field
                    v-model="dataSearchEmployee"
                    :rules="rulesSearch"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    color="indigo"
                    class="ma-0 white--text"
                    @click="searchEmployee(dataSearchEmployee)"
                  >
                    ค้นหา
                    <!-- <v-icon right dark>mdi-search</v-icon> -->
                  </v-btn>
                </v-col>
            </v-layout>
              <h2 class="txt-head">
                ข้อมูลส่วนตัว
              </h2>
              <v-divider
              class="mx-4"
              inset
              vertical
            ></v-divider>
              <v-layout class="row ml-10">
                <v-col cols="2">
                  <p class="txt-font" style="margin-top: 1.5%;">คำนำหน้า(ไทย)</p>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="preNameTh"
                    readonly
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="1">
                  <p class="txt-font" style="margin-top: 1.5%;">ชื่อ(ไทย)</p>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="fNameTh"
                    readonly
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="1">
                  <p class="txt-font" style="margin-top: 1.5%;">นามสกุล(ไทย)</p>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="lNameTh"
                    readonly
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
              </v-layout>
              <v-layout class="row ml-10">
                <v-col cols="2">
                  <p class="txt-font" style="margin-top: 1.5%;">คำนำหน้า(Eng)</p>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="preNameEng"
                    readonly
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="1">
                  <p class="txt-font" style="margin-top: 1.5%;">ชื่อ(Eng)</p>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="fNameEng"
                    readonly
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="1">
                  <p class="txt-font" style="margin-top: 1.5%;">นามสกุล(Eng)</p>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="lNameEng"
                    readonly
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
              </v-layout>
              <v-layout class="row ml-10">
                <v-col cols="2">
                  <p class="txt-font" style="margin-top: 1.5%;">Account ID</p>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="accountId"
                    readonly
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="1">
                  <p class="txt-font" style="margin-top: 1.5%;">วันเกิด</p>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="birthDate"
                    readonly
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="1">
                  <p class="txt-font" style="margin-top: 1.5%;">E-mail</p>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="email"
                    readonly
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
              </v-layout>
              <!-- ข้อมูลพนักงาน -->
              <h2 class="txt-head">
                ข้อมูลพนักงาน
              </h2>
              <v-divider
              class="mx-4"
              inset
              vertical
              ></v-divider>
              <v-layout class="row ml-10">
                  <v-col cols="2">
                    <p class="txt-font" style="margin-top: 1.5%;">บริษัท</p>
                  </v-col>
                  <v-col cols="2">
                    <!-- <v-select
                      v-model="companyName"
                      dense
                      :items="['INET', 'OGS']"
                      outlined
                    ></v-select> -->
                    <v-select
                      dense
                      v-model="companyName"
                      :items="itemCompany"
                      label="เลือก บริษัท"
                      item-text="companyFullNameEng"
                      item-value="_id"
                      outlined
                      :rules="rulesCompany"
                      @change="searchSelect()"
                    ></v-select>
                  </v-col>
                  <v-col cols="1">
                    <p class="txt-font" style="margin-top: 1.5%;">รหัสพนักงาน</p>
                  </v-col>
                  <v-col cols="2">
                    <v-text-field
                      v-model="employeeId"
                      :rules="rulesEmployeeId"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="1">
                    <p class="txt-font" style="margin-top: 1.5%;">สายงาน</p>
                  </v-col>
                  <v-col cols="2">
                    <v-select
                      dense
                      v-model="lineOfWork"
                      :items="itemLineOfWork"
                      label="เลือก สายงาน"
                      item-text="orgChartName"
                      item-value="_id"
                      outlined
                    ></v-select>
                  </v-col>
                </v-layout>
                <v-layout class="row ml-10">
                  <v-col cols="2">
                    <p class="txt-font" style="margin-top: 1.5%;">ฝ่ายงาน</p>
                  </v-col>
                  <v-col cols="2">
                    <v-select
                      dense
                      v-model="department"
                      :items="itemDepartment"
                      label="เลือก ฝ่ายงาน"
                      item-text="orgChartName"
                      item-value="_id"
                      outlined
                    ></v-select>
                  </v-col>
                  <v-col cols="1">
                    <p class="txt-font" style="margin-top: 1.5%;">ส่วนงาน</p>
                  </v-col>
                  <v-col cols="2">
                    <v-select
                      dense
                      v-model="section"
                      :items="itemSection"
                      label="เลือก ส่วนงาน"
                      item-text="orgChartName"
                      item-value="_id"
                      outlined
                    ></v-select>
                  </v-col>
                  <v-col cols="1">
                    <p class="txt-font" style="margin-top: 1.5%;">หน่วยงาน</p>
                  </v-col>
                  <v-col cols="2">
                    <v-select
                      dense
                      v-model="agency"
                      :items="itemAgency"
                      label="เลือก หน่วยงาน"
                      item-text="orgChartName"
                      item-value="_id"
                      outlined
                    ></v-select>
                  </v-col>
                </v-layout>
                <v-layout class="row ml-10">
                  <v-col cols="2">
                    <p class="txt-font" style="margin-top: 1.5%;">กลุ่มงาน</p>
                  </v-col>
                  <v-col cols="2">
                    <v-select
                      dense
                      v-model="workGroup"
                      :items="itemWorkGroup"
                      label="เลือก กลุ่มงาน"
                      item-text="orgChartName"
                      item-value="_id"
                      outlined
                    ></v-select>
                  </v-col>
                  <v-col cols="1">
                    <p class="txt-font" style="margin-top: 1.5%;">ตำแหน่ง</p>
                  </v-col>
                  <v-col cols="2">
                    <v-select
                      dense
                      v-model="position"
                      :items="itemPosition"
                      label="เลือก ตำแหน่งงาน"
                      item-text="orgChartName"
                      item-value="_id"
                      :rules="rulesPosition"
                      outlined
                    ></v-select>
                  </v-col>
                </v-layout>
                <v-layout class="row ml-10">
                  <v-col cols="2">
                    <p class="txt-font" style="margin-top: 1.5%;">รูปภาพ</p>
                  </v-col>
                  <v-col cols="2">
                    <v-card flat class="box-image" @change="ChooseBanner()">
                      <v-img :src="this.imageUrl" contain/>
                      <input type="file" id="files" ref="Pickfiles" v-on:change="onBannerSelected()"/>
                    </v-card>
                  </v-col>
                </v-layout>
          </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialogCreate()">Close</v-btn>
          <v-btn color="blue darken-1" text @click="submitData()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'
export default {
  data () {
    return {
      dialogCreate: false,
      textTitle: '',
      preNameTh: '',
      fNameTh: '',
      lNameTh: '',
      preNameEng: '',
      fNameEng: '',
      lNameEng: '',
      accountId: '',
      birthDate: '',
      email: '',
      companyName: '',
      employeeId: '',
      lineOfWork: '',
      department: '',
      section: '',
      agency: '',
      workGroup: '',
      position: '',
      type: 'หน่วยงาน',
      dataSearchEmployee: '',
      itemCompany: [],
      itemLineOfWork: [],
      itemDepartment: [],
      itemAgency: [],
      itemSection: [],
      itemWorkGroup: [],
      itemPosition: [],
      files: [],
      img: '',
      imageUrl: '',
      tokenUser: '',
      rulesEmployeeId: [
        v => !!v || 'กรุณากรอกรหัสพนักงาน'
        // v => (v && v.length === '') || 'Name must be less than 10 characters'
      ],
      rulesCompany: [
        v => !!v || 'กรุณาเลือกบริษัท'
      ],
      rulesPosition: [
        v => !!v || 'กรุณาเลือกตำแหน่ง'
      ],
      rulesSearch: [
        v => !!v || 'กรุณากรอก Username หรือ E-mail'
      ]
    }
  },
  mounted () {
    EventBus.$on('opendialogcreate', this.openDialogCreate)
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    this.getSelectCompany()
  },
  methods: {
    editCompany (value) {
      this.textTitle = ''
      // this.dialogCreate = true
      this.textTitle = value
    },
    async searchSelect () {
      // console.log('Value Select', this.companyName)
      await this.axios({
        method: 'post',
        url: `${this.api}/api/vMonk/orgChart/SelectPNodeByTypeAndCompId`,
        data: {
          companyId: this.companyName,
          orgChartType: this.type
        }
      }).then((response) => {
        if (response.data.success) {
          // console.log(response.data.result)
          this.itemLineOfWork = response.data.result
          // console.log('line of work', this.itemLineOfWork)
          this.itemDepartment = response.data.result
          this.itemAgency = response.data.result
          this.itemSection = response.data.result
          this.itemWorkGroup = response.data.result
          this.itemPosition = response.data.result
        } else {
          console.log('Error')
        }
      }).catch(e => {
        console.log(e)
      })
    },
    async getSelectCompany () {
      await this.axios({
        method: 'get',
        url: `${this.api}/api/vMonk/orgChart/getSelectCompanies`
      }).then((response) => {
        this.itemCompany = response.data.result
      }).catch(e => {
        console.log(e)
      })
    },
    async searchEmployee (value) {
      await this.axios({
        method: 'post',
        url: `${this.api}/api/vMonk/users/searchUserOne`,
        data: {
          keySearch: value
        }
      }).then((response) => {
        if (response.data.success) {
          // console.log(response)
          this.preNameTh = response.data.result.titleTh
          this.fNameTh = response.data.result.firstNameTh
          this.lNameTh = response.data.result.lastNameTh
          this.preNameEng = response.data.result.titleEn
          this.fNameEng = response.data.result.firstNameEn
          this.lNameEng = response.data.result.lastNameEn
          this.accountId = response.data.result.accountId
          this.birthDate = response.data.result.birthday
          this.email = response.data.result.emailOneId
        } else {
          console.log('Error')
          this.preNameTh = ''
          this.fNameTh = ''
          this.lNameTh = ''
          this.preNameEng = ''
          this.fNameEng = ''
          this.lNameEng = ''
          this.accountId = ''
          this.birthDate = ''
          this.email = ''
        }
      }).catch(e => {
        console.log(e)
        this.preNameTh = ''
        this.fNameTh = ''
        this.lNameTh = ''
        this.preNameEng = ''
        this.fNameEng = ''
        this.lNameEng = ''
        this.accountId = ''
        this.birthDate = ''
        this.email = ''
      })
    },
    openDialogCreate (value) {
      this.dialogCreate = value
    },
    closeDialogCreate () {
      this.dialogCreate = false
      EventBus.$emit('closedialogcreate', this.dialogCreate)
    },
    async submitData () {
      var chartId = '5f72a90efbd99687c0ee8a52'
      var formData = new FormData()
      formData.append('username', this.dataSearchEmployee)
      formData.append('companyId', this.companyName)
      formData.append('employeeId', this.employeeId)
      formData.append('type', this.type)
      formData.append('chartsId', chartId)
      formData.append('positionId', '5f733ecd8557eb0fac548e3c')
      formData.append('image', this.files[0])
      if (this.dataSearchEmployee === '' || this.employeeId === '' || this.position === '') {
        swal('Warning', 'กรุณากรอกข้อมูลให้ครบ', 'warning')
      } else {
        await this.axios({
          method: 'post',
          url: `${this.api}/api/vMonk/users/insertUsers`,
          headers: {
            authorization: this.tokenUser
          },
          data: formData
        }).then((response) => {
          swal('Success', 'จัดการพนักงาน สำเร็จ', 'success')
          this.dialogCreate = false
          // this.getCompanyLists()
        }).catch(e => {
          console.dir(e)
          swal('Error', 'กรุณาลองใหม่', 'error')
        })
      }
    },
    ChooseBanner () {
      this.$refs.Pickfiles.click()
    },
    onBannerSelected () {
      this.files = []
      var uploadedImage = this.$refs.Pickfiles.files
      var dotindex = uploadedImage[0].name.lastIndexOf('.')
      var FileExtension = uploadedImage[0].name.substr(dotindex + 1).toLowerCase()
      if (FileExtension === 'jpg' || FileExtension === 'png' || FileExtension === 'JPG' || FileExtension === 'PNG') {
        if (!uploadedImage[0]) return
        const reader = new FileReader()
        reader.readAsDataURL(uploadedImage[0])
        reader.onload = evt => {
          var img = new Image()
          this.files.push(uploadedImage[0])
          // console.log(this.files[0])
          const fr = new FileReader()
          fr.readAsDataURL(this.files[0])
          fr.addEventListener('load', () => {
            this.nameimg = this.files[0].name
            this.imageUrl = fr.result
          })
          img.src = evt.target.result
        }
        // reader.onerror = evt => {
        //   console.error(evt)
        // }
      }
    }
  }
}
</script>
<style scoped>
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.txt-font {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
</style>
